<template>
  <v-expansion-panel class="custom-panel-not" expand>
    <v-expansion-panel-content v-for="(stage, i) in stages" :key="`stage-${i}`" :value="togglePane" expand-icon="fas fa-caret-down fa-xs black--text">
      <template slot="header">
        <v-layout class="my-2" row wrap justify-space-between align-center>
          <v-flex md6 class="p-0">
            <v-avatar :size="50" class="my-1 k-orange-linear">
              <h2>{{ i + 1 }}</h2>
            </v-avatar>
            <h3 class="ml-3 title d-inline-block">{{ stage.name || (formatDayOff(stage.days_off)) }}</h3>
          </v-flex>
          <v-flex md5 class="justify-center text-xs-left d-flex align-center">
            <v-tooltip bottom>
              <template slot="activator">
                <div class="date-frame">
                  <img :src="require('@/assets/img/date_mod_icon.svg')" class="mr-1 date-icon" alt="date_mod">
                  <span class="ml-1">{{ stage.updated_at | formatDate }}</span>
                </div>
              </template>
              Ultima actualización
            </v-tooltip>
          </v-flex>
          <v-flex md1 class="text-xs-left" v-if="!canCreate">
            <v-icon @click.stop="editStage(stage)" class="mr-3" color="black" small>fas fa-pencil-alt</v-icon>
            <v-icon @click.stop="toggleStageStatus(stage)" class="status-btn"
              :color="stage.status === 'Activo' || stage.status === 1 ? 'green' : 'red'" small>
              fas fa-power-off
            </v-icon>
          </v-flex>
        </v-layout>
      </template>
      <v-card>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 class="justify-end d-flex align-center">
              <v-btn v-if="!canCreate" @click.stop="createFilter(stage)" class="k-orange-linear white--text create-btn">CREAR
                ESTRATEGIA</v-btn>
            </v-flex>
            <v-flex md12 class="mt-3 mb-3">
              <v-divider />
            </v-flex>
            <v-flex md12 class="pb-3 filters-container">
              <filter-item
                :key="`filter-${filterIndex}`"
                v-for="(filter, filterIndex) in stage.filters"
                :filter="filter"
                :position="filterIndex + 1"
                :is-whatsapp-outbound-active="isWhatsappOutboundActive"
                @edit="editFilter($event, stage)"
                @change-filter-status="toggleStatus($event,filter, stage)"
                @edit-template="editTemplate($event, stage)"
                @open-trigger-modal="openTriggerModal($event, filter, stage)"
                @change-channel-status="toggleStatus($event,filter, stage)"
                @test-template="$emit('test-template', $event)"
                @change-filter-config="changeFilterConfig"
              />
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-expansion-panel-content>
    <template-dialog
      :title="`Ajustes de canal ${templateChannel === 'human' ? 'humano' : templateChannel}`"
      :show="templateDialog"
      :channel="templateChannel"
      :template="editingTemplate"
      :append-vars="templateVars"
      :activate-check="activateCheck"
      :filter="editingFilter"
      :validation-email-scope="validationEmailScope"
      :template-staging="templateStaging"
      :is-in-release="isInRelease"
      :is-new-workflow="true"
      :disabled-btn="canCreate"
      @save="saveTemplate"
      @close="closeTemplateDialog"
    />
    <ivr-templates-dialog
      :show="ivrTemplatesDialog"
      :is-payment-type="isPaymentType"
      :is-in-release="isInRelease"
      :ivrTemplate="editingTemplate"
      :is-new-workflow="true"
      :disabled-btn="canCreate"
      @save="updateChannel"
      @close="closeTemplateDialog"
    />
    <bot-templates-dialog
      :show="botTemplatesDialog"
      :is-payment-type="isPaymentType"
      :is-in-release="isInRelease"
      :botTemplate="editingTemplate"
      :is-new-workflow="true"
      :disabled-btn="canCreate"
      @save="updateChannel"
      @close="closeTemplateDialog"
    />
    <whatsapp-templates-dialog
      :show="whatsappTemplatesDialog"
      :is-payment-type="isPaymentType"
      :is-in-release="isInRelease"
      :workflow-filter="editingTemplate"
      :is-new-workflow="true"
      @save="updateChannel"
      @close="closeTemplateDialog"
    />
    <triggers-modal
      :show="triggerModal"
      :filter="editingFilter"
      :source-channel="triggerChannel"
      @filter-updated="triggersUpdated"
      @update:show="triggerModal = $event"
    />
  </v-expansion-panel>
</template>


<script>
import _ from 'lodash';
import moment from 'moment';

import EventBus from '@/event-bus';
import permissionsMixin from '@/mixins/permissions';

import FilterItem from './FilterItem.vue';
import channelsMixin from '@/mixins/channelsV2';
import filtersMixin from '@/mixins/workflowFilters';
import TemplateDialog from '@/components/Templates/Index';
import comparsionOperatorsMixin from '@/mixins/comparisonOperators';
import EditModal from '@/components/V2CollectWorkflows/Detail/WorkflowDetail/editModal';
import StageModal from '@/components/V2CollectWorkflows/Detail/WorkflowTree/StageModal';
import TriggersModal from '@/components/V2CollectWorkflows/Detail/WorkflowDetail/TriggersModal';
import IvrTemplatesDialog from '@/components/V2CollectWorkflows/Detail/WorkflowTree/IvrTemplates';
import BotTemplatesDialog from '@/components/V2CollectWorkflows/Detail/WorkflowTree/BotTemplates';
import PFilterModal from '@/components/V2CollectWorkflows/Detail/PaymentPromiseTree/PFilterModal';
import WhatsappTemplatesDialog from '@/components/V2CollectWorkflows/Detail/WorkflowTree/WhatsappTemplates';

const WORKFLOW_TEMPLATE_STAGING_CHANNEL_IDS = {
  email: 1,
  sms: 2,
  whatsapp: 7,
  human: 5,
};

export default {
  inject: {
    $validator: '$validator',
  },
  props: {
    stages: {
      type: Array,
      required: true,
    },
    toggleAll: {
      type: Boolean,
      default: false,
    },
    isInRelease: {
      type: Boolean,
      default: false,
    },
    isGlobal: {
      type: Boolean,
      default: false,
    },
    isWhatsappOutboundActive: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    EditModal,
    StageModal,
    FilterItem,
    PFilterModal,
    TriggersModal,
    TemplateDialog,
    BotTemplatesDialog,
    IvrTemplatesDialog,
    WhatsappTemplatesDialog,
  },
  mixins: [
    filtersMixin,
    channelsMixin,
    comparsionOperatorsMixin,
    permissionsMixin,
  ],
  data() {
    return {
      openAll: false,
      togglePane: false,
      toggleValues: {
        'Activo': 'Inactivo',
        'Inactivo': 'Activo',
      },
      daysOffG: {
        'human': 'g1',
        'bot': 'g2',
        'ivr': 'g2',
        'sms': 'g3',
        'email': 'g4',
        'whatsapp': 'g5',
      },
      validationEmailScope: 'companyEmail',
      editingFilter: {},
      emailStaging: {},
      templateStaging: {},
      smsStaging: {},
      templateDialog: false,
      botTemplatesDialog: false,
      ivrTemplatesDialog: false,
      whatsappTemplatesDialog: false,
      smsConfigDialog: false,
      templateChannel: '',
      editingTemplate: {},
      editingStage: {},
      editStrategyModal: false,
      pFilterModal: false,
      stageModal: false,
      triggerModal: false,
      triggerChannel: '',
    };
  },
  filters: {
    formatDate(date) {
      return moment(date).format('DD/MM/YYYY');
    },
  },
  computed: {
    isPaymentType() {
      return 'broken_promises' in this.editingFilter;
    },
    canCreate() {
      return !this.checkPermissions([
        'create_workflow_notifications',
        'edit_workflow_notifications',
      ]);
    },
    activateCheck() {
      const filter = this.editingFilter || {};
      const template = filter.template || {};
      return (
        (
          this.templateChannel === 'email'
          || this.templateChannel === 'sms'
        )
        && template.id
        && !!template[this.templateChannel]
      );
    },
  },
  methods: {
    async applyChannelConfig(event){
      const response = await this.sendFilterRequest(this.editingFilter.id, event, this.isPaymentType);

    if (!response) {
      EventBus.$emit('modal', 'Error al guardar, por favor intente nuevamente')
    }
    this.$emit('filter-updated', { filter: response, selectedStage: this.editingStage });
    },
    closeTemplateDialog() {
      const channel = this.templateChannel;
      this.editingTemplate = {};
      if ((this.isPaymentType && channel !== 'whatsapp' && channel !== 'ivr') || (channel === 'sms' || channel === 'email' || channel === 'human')) {
        this.templateChannel = '';
        this.templateDialog = false;
        this.templateStaging = {};
      }
      else if (channel === 'ivr') {
        this.ivrTemplatesDialog = false;
      } else if (channel === 'bot') {
        this.botTemplatesDialog = false;
      } else if (channel === 'whatsapp') {
        this.whatsappTemplatesDialog = false;
      }
    },
    openTriggerModal({ channelName }, filter, stage) {
      this.editingStage = stage;
      this.editingFilter = filter;
      this.triggerChannel = channelName;
      this.triggerModal = true;
    },
    triggersUpdated(event) {
      this.editingFilter = event;
      this.$emit('filter-updated', { filter: event, selectedStage: this.editingStage });
    },
    editTemplate(event, stage) {
      const { filter, channel } = event;
      this.editingFilter = filter;
      this.editingStage = stage;
      this.templateChannel = channel;
      this.validationEmailScope = `${stage.id}-companyEmail`;
      if ((this.isPaymentType && channel !== 'whatsapp' && channel !== 'ivr') || (channel === 'sms' || channel === 'email' || channel === 'human')) {
        const template = filter.template || {};
        this.templateStaging = {};
        this.editingTemplate = {
          text: template[channel] || '',
          ...channel === 'email' && {
            company_email_id: template.company_email_id,
            subject: template.subject,
            email_name: template.name,
          },
          ...(channel === 'sms') && {
            sms_enable_short_url: template.sms_enable_short_url,
          },
        };
        if (!template.id) {
          this.templateDialog = true;
          return;
        }
        this.axios.get(`templates/staging/${template.id}`)
        .then((response) => {
          const { data } = response;
          if (!data.length) {
            this.templateStaging = {};
            this.templateDialog = true;
            return;
          }
          const wantedId = WORKFLOW_TEMPLATE_STAGING_CHANNEL_IDS[channel];
          const element = wantedId !== undefined
            ? data.find(row => Number(row.channel_id) === wantedId)
            : data[0];
          if (!element) {
            this.templateStaging = {};
            this.templateDialog = true;
            return;
          }
          this.templateStaging = { ..._.omit(element, 'body'), text: element.body };
          this.templateDialog = true;
        })
        .catch(() => {
          this.templateStaging = {};
          EventBus.$emit('modal', 'Error al cargar la plantilla, por favor intente nuevamente');
        });
      } else {
        this.editingTemplate = {
          [`${channel}_calls_queue`]: filter[`${channel}_calls_queue`],
          max_attempts: filter[`${channel}_max_attempts`],
          [`${channel}_template_id`]: filter[`${channel}_template_id`],
          [`days_off_${this.daysOffG[channel]}`]: filter[`days_off_${this.daysOffG[channel]}`],
          [`days_off_attemps_${this.daysOffG[channel]}`]: filter[`days_off_attemps_${this.daysOffG[channel]}`],
          [`attemps_${this.daysOffG[channel]}`]: filter[`attemps_${this.daysOffG[channel]}`],
          ...(channel === 'ivr' || channel === 'bot' || channel === 'whatsapp') && {
            [`${channel}_owner_id`]: filter[`${channel}_owner_id`],
          },
          ...(channel === 'whatsapp') && {
            colly_whatsapp_template_id: filter.colly_whatsapp_template_id,
            colly_whatsapp_sender_id: filter.colly_whatsapp_sender_id,
          },
        };
        if (channel === 'ivr') {
          this.ivrTemplatesDialog = true;
        } else if (channel === 'bot') {
          this.botTemplatesDialog = true;
        } else if (channel === 'whatsapp') {
          this.whatsappTemplatesDialog = true;
        }

      }
    },
    editStage(stage) {
      this.$emit('edit-stage', stage);
    },
    toggleStageStatus(stage) {
      let newStatus;
      const isPaymentType = !('name' in stage);
      if (!isPaymentType) {
        newStatus = this.toggleValues[stage.status]
      } else {
        newStatus = stage.status ^ 1;
      }
      const payload = { status: newStatus };
      this.$emit('change-stage-status', { stageId: stage.id, payload, isPaymentType });
    },
    editFilter(filter, stage) {
      this.$emit('edit-stage-filter', { stage, filter });
    },
    createFilter(stage) {
      this.$emit('create-stage-filter', stage);
    },
    async updateChannel(form) {
      const response = await this.sendFilterRequest(this.editingFilter.id, form, this.isPaymentType);

      if (!response) {
        EventBus.$emit('modal', 'Error al guardar, por favor intente nuevamente')
      }
      this.$emit('filter-updated', { filter: response, selectedStage: this.editingStage });
    },
    async saveTemplate(form) {
      const isValid = (form.text !== '' && form.text !== null) || form.channel === 'human' || !!form.colly_template_id;
      console.log("form", form)
      this.templateDialog = false;

      if (form.momentToApply === 'now' || !['create', 'update'].includes(form.actionType)) {
        const templateForm = {
          ...this.templateChannel === 'email' && !form.colly_template_id && {
            company_email_id: form.company_email_id,
            subject: form.subject,
            email_name: form.email_name,
          },
          ...(!form.colly_template_id && {
            [this.templateChannel]: form.text,
          }),
          ...(form.colly_template_id && {
            [`colly_${this.templateChannel}_template_id`]: form.colly_template_id,
            [`colly_${this.templateChannel}_sender_id`]: form.colly_sender_id,
          }),
        };
        if (isValid) {
          const daysOffKey = this.daysOffG[this.templateChannel];

          const payload = {
            ...templateForm,
            sms_cs_journey: form.sms_cs_journey,
            sms_check_days: form.sms_check_days,
            only_contacted_sms: form.only_contacted_sms,
            sms_enable_short_url: form.sms_enable_short_url,
            [daysOffKey]: form[daysOffKey],
            [`attemps_${this.daysOffG[this.templateChannel]}`]: form[`attemps_${this.daysOffG[this.templateChannel]}`],
            [`days_off_attemps_${this.daysOffG[this.templateChannel]}`]: form[`days_off_attemps_${this.daysOffG[this.templateChannel]}`],
            [`days_off_${this.daysOffG[this.templateChannel]}`]: form[`days_off_${this.daysOffG[this.templateChannel]}`],
            ...(this.templateChannel === 'sms' || this.templateChannel === 'human') && {
              [`${this.templateChannel}_owner_id`]: form[`${this.templateChannel}_owner_id`],
            },
          };
          const response = await this.sendFilterRequest(this.editingFilter.id, payload, this.isPaymentType);

          if (!response) {
            EventBus.$emit('modal', 'Error al guardar, por favor intente nuevamente')
          }
          this.$emit('filter-updated', { filter: response, selectedStage: this.editingStage });
        }
      } else {
        if (form.channel === 'email') {
          this.emailStaging = form;
          form.channel_id = 1;
        } else {
          this.smsStaging = form;
          form.channel_id = 2;
        }

        const templateId = (this.editingFilter.template || {}).id;
        if (form.actionType === 'create') {
          this.axios.post('templates/staging', {
            ...form,
            company_id: this.$auth.user().company_id,
            template_id: templateId,
            type: 'workflow_notification',
          })
            .then(() => EventBus.$emit('modal', 'Guardado exitoso'))
            .catch(() => EventBus.$emit('modal', 'Error al guardar, por favor intente nuevamente'));
        } else if (form.actionType === 'update') {
          this.axios.patch(`templates/staging/${templateId}`, {
            ...form,
            company_id: this.$auth.user().company_id,
            template_id: templateId,
            type: 'workflow_notification',
          })
            .then(() => EventBus.$emit('modal', 'Plantilla actualizada con éxito'))
            .catch(() => EventBus.$emit('modal', 'Error al guardar, por favor intente nuevamente'))
        }
      }
    },
    formatDayOff(number) {
      let result = `${number} Día`;
      if (number !== 1) {
        result = `${number} Días`;
      }
      return `${result} antes del compromiso`;
    },
    async toggleStatus(event, filter, stage) {
      this.editingFilter = filter;
      this.editingStage = stage;
      await this.updateChannel(event);
      this.editingFilter = {}
      this.editingStage = {};
    },
    async sendFilterRequest(filterId, payload, isPaymentType) {
      let url = 'v2/workflow_filters';

      if (isPaymentType) {
        url = 'payment_p_filters';
      }
      const updated = this.axios.patch(`${url}/${filterId}`, payload)
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          return false;
        });

      return updated;
    },
    async changeFilterConfig(event) {
      const { filterId, isPaymentType, data} = event;

      const response = await this.sendFilterRequest(filterId, data, isPaymentType);

      if (!response) {
        EventBus.$emit('modal', 'Error al guardar, por favor intente nuevamente')
      }
    },
  },
  watch: {
    toggleAll() {
      this.togglePane = this.toggleAll;
    },
  },
};
</script>

<style scoped>
.title {
  font-weight: bold;
}
.date-icon {
  max-width: 25px;
  height: 20px;
}

.date-frame {
  max-width: 130px;
  height: 37px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0;
  margin-left: 0;
  padding: 0;
  color: #161615;
}

.date-frame:hover {
  cursor: pointer;
  background-color: #EDEDED;
  border-radius: 19px;
}

.create-btn {
  max-width: 156px;
}

.filters-container {
  border-radius: 3px;
  box-shadow: 0px 3px 10px #0000001C;
  height: max-content !important;
}

.status-btn {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/V2CollectWorkflows/Detail/WorkflowDetail/StageListV2.vue